import {
  KoobInputCheckbox,
  KoobTable,
  KoobTableHeader,
  KoobTableBody,
  KoobTableRow,
  KoobTableHead,
  KoobTableCell,
} from '@koob/ui';
import KoobSpinner from '@koob/ui/src/components/KoobSpinner';
import { NotificationChannelEnum } from '@koob/enums';

export default function NotificationPreferencesEditor({
  preferences,
  setPreferences,
  loading = false,
}) {
  const handleCheckboxChange = (preference, channel, checked) => {
    const updatedPreferences = preferences.map((pref) => {
      if (pref.type === preference.type) {
        return { ...pref, [channel]: checked };
      }
      return pref;
    });
    setPreferences(updatedPreferences);
  };

  return (
    <div className="bg-gray-50 p-4 rounded">
      {!loading ? (
        <KoobTable>
          <KoobTableHeader>
            <KoobTableRow>
              <KoobTableHead>Notification Type</KoobTableHead>
              <KoobTableHead align="center">Email</KoobTableHead>
              <KoobTableHead align="center">In-App</KoobTableHead>
            </KoobTableRow>
          </KoobTableHeader>

          <KoobTableBody>
            {preferences.map((preference) => (
              <KoobTableRow key={preference.type}>
                <KoobTableCell>{preference.label}</KoobTableCell>

                <KoobTableCell>
                  <div className="flex justify-center">
                    <KoobInputCheckbox
                      checked={
                        preference.channelMail &&
                        preference.availableChannels.includes(
                          NotificationChannelEnum.MAIL,
                        )
                      }
                      onCheckedChange={(checked) =>
                        handleCheckboxChange(preference, 'channelMail', checked)
                      }
                      disabled={
                        !preference.availableChannels.includes(
                          NotificationChannelEnum.MAIL,
                        )
                      }
                    />
                  </div>
                </KoobTableCell>

                <KoobTableCell>
                  <div className="flex justify-center">
                    <KoobInputCheckbox
                      checked={
                        preference.channelDatabase &&
                        preference.availableChannels.includes(
                          NotificationChannelEnum.DATABASE,
                        )
                      }
                      onCheckedChange={(checked) =>
                        handleCheckboxChange(
                          preference,
                          'channelDatabase',
                          checked,
                        )
                      }
                      disabled={
                        !preference.availableChannels.includes(
                          NotificationChannelEnum.DATABASE,
                        )
                      }
                    />
                  </div>
                </KoobTableCell>
              </KoobTableRow>
            ))}
          </KoobTableBody>
        </KoobTable>
      ) : (
        <div className="flex justify-center items-center h-64">
          <KoobSpinner />
        </div>
      )}
    </div>
  );
}
